import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import ClaimBanner from "@/pages/website-landing/components/claim-banner/ClaimBanner"
import ContactForm from "@/pages/website-landing/home/sections/info-contact/contact-form/ContactForm"
import { Col, Row } from "antd"
import { FC } from "react"
import "./InfoContact.less"
import infoBg from "./images/useful-info-bg.webp"

const { Title } = WebsiteTypography

type Props = {
  isBannerVisible?: boolean
  paddingTop?: number
}

const InfoContact: FC<Props> = ({ isBannerVisible = true, paddingTop }) => {
  return (
    <div className={"info-section-wrapper"} style={{ paddingTop: paddingTop || 0 }}>
      <div className={"info-section-bg"}>
        <img src={infoBg} alt={""} loading={"lazy"} decoding={"async"} />
      </div>
      <div className={"container"}>
        {isBannerVisible && (
          <Row className={"contact-banner-container"} justify={"center"}>
            <Col span={24} xxl={18} xl={18} lg={18} md={20} sm={20} xs={24}>
              <ClaimBanner type={"ready-to-simplify"} />
            </Col>
          </Row>
        )}

        <Row justify={"center"} className={"form-container"} id={"contact"}>
          <Col span={16} xxl={16} xl={16} lg={16} md={16} sm={20} xs={24}>
            <Title level={3} centered className={"form-section-title"}>
              <span className={"bold"}>{"Quick "}</span>
              <span className={"w300"}>{"Contact "}</span>
            </Title>
            <ContactForm isDashboard={false} />
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default InfoContact
